  // Indian number formatting function - make it globally available
  window.formatIndianPrice = function formatIndianPrice(price) {
    // Convert price to string and extract components
    let priceStr = price.toString().trim();

    // Check if it's a negative value (starts with - or contains -)
    let isNegative = priceStr.includes('-');

    // Extract currency symbol
    let currencyMatch = priceStr.match(/[^\d.,\s-]+/);
    let currency = currencyMatch ? currencyMatch[0] : '₹';

    // Extract numeric value and remove currency symbol, spaces, and minus
    let numStr = priceStr.replace(/[^\d.-]/g, '');
    let num = Math.abs(parseFloat(numStr));

    if (isNaN(num)) return price;

    // Split into integer and decimal parts
    let parts = num.toFixed(2).split('.');
    let integerPart = parts[0];
    let decimalPart = parts[1];

    // Apply Indian comma formatting
    let formatted = '';
    let len = integerPart.length;

    if (len <= 3) {
      formatted = integerPart;
    } else {
      // Add commas for Indian format (last 3 digits, then every 2 digits)
      let lastThree = integerPart.slice(-3);
      let remaining = integerPart.slice(0, -3);

      if (remaining.length <= 2) {
        formatted = remaining + ',' + lastThree;
      } else {
        // Add commas every 2 digits for the remaining part
        let reversedRemaining = remaining.split('').reverse().join('');
        let formattedRemaining = reversedRemaining.match(/.{1,2}/g).join(',');
        formatted = formattedRemaining.split('').reverse().join('') + ',' + lastThree;
      }
    }

    // Return formatted price with proper negative sign placement
    if (isNegative) {
      return '-' + currency + formatted + '.' + decimalPart;
    } else {
      return currency + formatted + '.' + decimalPart;
    }
  }

  // Format all price elements when DOM is loaded
  document.addEventListener('DOMContentLoaded', function () {
    function formatAllPrices() {
      // Only format cart subtotal and breakdown prices within cart drawer
      const cartDrawer = document.querySelector('#CartDrawer');
      if (!cartDrawer) return;

      // Format only cart footer subtotal and breakdown values
      const subtotalElements = cartDrawer.querySelectorAll(
        '.cart-footer__subtotal-value, .cart-footer__breakdown-value'
      );
      subtotalElements.forEach((element) => {
        if (element.textContent && !element.dataset.formatted) {
          element.textContent = formatIndianPrice(element.textContent);
          element.dataset.formatted = 'true';
        }
      });
    }

    // Initial formatting
    formatAllPrices();

    // Price formatting and DOM observation is now handled by CartUpdateManager
    // MutationObserver disabled to prevent cascading updates
  });

  // Minimal Cart Manager - Just for compatibility
  class SimpleCartManager {
    constructor() {
      console.log('SimpleCartManager initialized (minimal version)');
    }

    // Minimal methods for compatibility
    showLoading() {
      console.log('SimpleCartManager.showLoading() - using cart-drawer methods');
    }

    hideLoading() {
      console.log('SimpleCartManager.hideLoading() - using cart-drawer methods');
    }

    // No complex methods needed here - cart-drawer.js handles most behavior.

    updatePriceStagesMessageOnly(cartSubtotal) {
      // Message updates are handled server-side in Liquid template
      // This function is kept for compatibility but doesn't need to do anything
      // as the message is rendered correctly on cart updates via AJAX refresh
    }

    updateMiniCollectionEfficiently(cartData) {
      // Mini collection visibility is now controlled by settings and cart state
      // The Liquid template handles conditional rendering based on cart state
      // This function is kept for compatibility but logic is now in Liquid
      const cartDrawerElement = document.querySelector('cart-drawer');
      const miniCollection = document.querySelector('.cart-drawer__mini-collection');
      
      if (cartDrawerElement && miniCollection) {
        const wasEmpty = cartDrawerElement.classList.contains('is-empty');
        const isNowEmpty = cartData.item_count === 0;
        
        // If cart state changed, trigger a full refresh to update recommendations
        if (wasEmpty !== isNowEmpty) {
          // Cart state changed - recommendations may need to be updated
          // This will be handled by the refreshCartDrawer function
          console.log('Cart state changed from', wasEmpty ? 'empty' : 'filled', 'to', isNowEmpty ? 'empty' : 'filled');
        }
      }
    }

    async fallbackFullUpdate() {
      // Only use full update as last resort
      console.log('Using fallback full update');

      const response = await fetch(`${window.routes?.cart_url || '/cart'}?section_id=cart-drawer`);
      const responseText = await response.text();

      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const newDrawerContent = html.querySelector('#CartDrawer .drawer__inner');
      const currentDrawerContent = this.drawer?.querySelector('.drawer__inner');

      if (newDrawerContent && currentDrawerContent) {
        // Store scroll position
        const scrollContainer = this.drawer.querySelector('.cart-drawer__scrollable');
        const currentScrollTop = scrollContainer ? scrollContainer.scrollTop : 0;

        // Update content
        currentDrawerContent.innerHTML = newDrawerContent.innerHTML;

        // Restore scroll position immediately
        requestAnimationFrame(() => {
          const newScrollContainer = this.drawer.querySelector('.cart-drawer__scrollable');
          if (newScrollContainer && currentScrollTop > 0) {
            newScrollContainer.scrollTop = currentScrollTop;
          }
        });

        // Reinitialize components
        this.reinitializeComponents();
      }
    }

    reinitializeComponents() {
      // Reinitialize quantity controls
      const quantityInputs = this.drawer?.querySelectorAll('.cart-drawer-quantity');
      quantityInputs?.forEach((input) => {
        const wrapper = input.closest('.cart-drawer-quantity-wrapper');
        if (wrapper) {
          this.initQuantityControls(wrapper);
        }
      });

      // Reinitialize expand/collapse
      this.initExpandCollapse();

      // Reinitialize mini collection navigation
      this.initMiniCollectionNavigation();

      // Reinitialize double offer carousel
      this.initDoubleOfferCarousel();

      // Reinitialize cart footer toggle
      this.initCartFooterToggle();

      // Initialize mini collection spacing based on footer state
      this.initMiniCollectionSpacing();

      // Format prices
      this.formatAllPrices();
    }

    formatAllPrices() {
      // Only format cart subtotal and breakdown prices within cart drawer
      const cartDrawer = document.querySelector('#CartDrawer');
      if (!cartDrawer) return;

      // Format only cart footer subtotal and breakdown values
      const subtotalElements = cartDrawer.querySelectorAll(
        '.cart-footer__subtotal-value, .cart-footer__breakdown-value'
      );
      subtotalElements.forEach((element) => {
        if (element.textContent && !element.dataset.formatted) {
          element.textContent = formatIndianPrice(element.textContent);
          element.dataset.formatted = 'true';
        }
      });
    }

    initQuantityControls(wrapper) {
      const input = wrapper.querySelector('.cart-drawer-quantity');
      const minusBtn = wrapper.querySelector('.cart-drawer-minus');
      const plusBtn = wrapper.querySelector('.cart-drawer-plus');

      if (!input || !minusBtn || !plusBtn) return;

      // Remove existing listeners
      minusBtn.replaceWith(minusBtn.cloneNode(true));
      plusBtn.replaceWith(plusBtn.cloneNode(true));

      const newMinusBtn = wrapper.querySelector('.cart-drawer-minus');
      const newPlusBtn = wrapper.querySelector('.cart-drawer-plus');

      newMinusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const currentValue = parseInt(input.value) || 0;
        if (currentValue > 0) {
          input.value = currentValue - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      newPlusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const currentValue = parseInt(input.value) || 0;
        input.value = currentValue + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    initExpandCollapse() {
      document.querySelectorAll('.cart-card__expand-trigger').forEach((trigger) => {
        // Remove existing listener
        trigger.replaceWith(trigger.cloneNode(true));
        const newTrigger = document.querySelector(`[data-target="${trigger.getAttribute('data-target')}"]`);

        newTrigger?.addEventListener('click', function () {
          const targetId = this.getAttribute('data-target');
          const targetElement = document.getElementById(targetId);
          if (targetElement) {
            const isHidden = targetElement.style.display === 'none' || !targetElement.style.display;
            targetElement.style.display = isHidden ? 'block' : 'none';
            this.textContent = isHidden ? '−' : '...';
          }
        });
      });
    }

    initMiniCollectionNavigation() {
      const prevButton = document.querySelector('.cart-drawer__mini-collection-nav--prev');
      const nextButton = document.querySelector('.cart-drawer__mini-collection-nav--next');
      const scrollContainer = document.querySelector('.cart-drawer__mini-collection-scroll');

      if (!prevButton || !nextButton || !scrollContainer) return;

      // Remove existing listeners
      prevButton.replaceWith(prevButton.cloneNode(true));
      nextButton.replaceWith(nextButton.cloneNode(true));

      const newPrevButton = document.querySelector('.cart-drawer__mini-collection-nav--prev');
      const newNextButton = document.querySelector('.cart-drawer__mini-collection-nav--next');

      // Update arrow visibility based on scroll position
      const updateArrows = () => {
        const scrollLeft = scrollContainer.scrollLeft;
        const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;

        // Show/hide prev button
        if (scrollLeft > 10) {
          newPrevButton.classList.add('visible');
        } else {
          newPrevButton.classList.remove('visible');
        }

        // Show/hide next button
        if (scrollLeft < maxScroll - 10) {
          newNextButton.classList.add('visible');
        } else {
          newNextButton.classList.remove('visible');
        }
      };

      newPrevButton?.addEventListener('click', () => {
        scrollContainer.scrollBy({ left: -200, behavior: 'smooth' });
      });

      newNextButton?.addEventListener('click', () => {
        scrollContainer.scrollBy({ left: 200, behavior: 'smooth' });
      });

      // Update arrows on scroll
      scrollContainer.addEventListener('scroll', updateArrows);

      // Initial check after a short delay to ensure content is loaded
      setTimeout(updateArrows, 100);
    }

    initDoubleOfferCarousel() {
      const prevButton = document.querySelector('.cart-drawer__double-offer-nav--prev');
      const nextButton = document.querySelector('.cart-drawer__double-offer-nav--next');
      const scrollContainer = document.querySelector('.cart-drawer__double-offer-scroll');

      if (!prevButton || !nextButton || !scrollContainer) return;

      // Remove existing listeners
      prevButton.replaceWith(prevButton.cloneNode(true));
      nextButton.replaceWith(nextButton.cloneNode(true));

      const newPrevButton = document.querySelector('.cart-drawer__double-offer-nav--prev');
      const newNextButton = document.querySelector('.cart-drawer__double-offer-nav--next');

      // Update arrow visibility based on scroll position
      const updateArrows = () => {
        const scrollLeft = scrollContainer.scrollLeft;
        const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;

        // Show/hide prev button
        if (scrollLeft > 10) {
          newPrevButton.classList.add('visible');
        } else {
          newPrevButton.classList.remove('visible');
        }

        // Show/hide next button
        if (scrollLeft < maxScroll - 10) {
          newNextButton.classList.add('visible');
        } else {
          newNextButton.classList.remove('visible');
        }
      };

      newPrevButton?.addEventListener('click', () => {
        scrollContainer.scrollBy({ left: -200, behavior: 'smooth' });
      });

      newNextButton?.addEventListener('click', () => {
        scrollContainer.scrollBy({ left: 200, behavior: 'smooth' });
      });

      // Update arrows on scroll
      scrollContainer.addEventListener('scroll', updateArrows);

      // Initial check after a short delay to ensure content is loaded
      setTimeout(updateArrows, 100);
    }

    initCartFooterToggle() {
      const toggleButton = document.querySelector('.cart-footer__breakdown-toggle');
      const breakdown = document.querySelector('.cart-footer__price-breakdown');

      if (!toggleButton || !breakdown) return;

      // Remove existing listener
      toggleButton.replaceWith(toggleButton.cloneNode(true));
      const newToggleButton = document.querySelector('.cart-footer__breakdown-toggle');

      newToggleButton?.addEventListener('click', function () {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const miniCollection = document.querySelector('.cart-drawer__mini-collection');

        if (isExpanded) {
          // Collapse
          this.setAttribute('aria-expanded', 'false');
          breakdown.classList.remove('expanded');
          
          // Adjust mini collection spacing when collapsed
          if (miniCollection) {
            miniCollection.classList.remove('footer-expanded');
          }
        } else {
          // Expand
          this.setAttribute('aria-expanded', 'true');
          breakdown.classList.add('expanded');
          
          // Adjust mini collection spacing when expanded
          if (miniCollection) {
            miniCollection.classList.add('footer-expanded');
          }
        }
      });
    }

    initMiniCollectionSpacing() {
      // Check current footer breakdown state and apply appropriate spacing
      const breakdown = document.querySelector('.cart-footer__price-breakdown');
      const miniCollection = document.querySelector('.cart-drawer__mini-collection');
      
      if (!breakdown || !miniCollection) return;
      
      // Check if breakdown is currently expanded
      if (breakdown.classList.contains('expanded')) {
        miniCollection.classList.add('footer-expanded');
      } else {
        miniCollection.classList.remove('footer-expanded');
      }
    }

    showLoader() {
      if (this.loader) {
        this.loader.classList.add('active');
      }
    }

    hideLoader() {
      setTimeout(() => {
        if (this.loader) {
          this.loader.classList.remove('active');
        }
      }, 300);
    }

    interceptCartRequests() {
      const originalFetch = window.fetch;
      window.fetch = (...args) => {
        const [url, options] = args;

        if (
          typeof url === 'string' &&
          (url.includes('/cart/add.js') || url.includes('/cart/update.js') || url.includes('/cart/change.js'))
        ) {
          console.log('Cart request intercepted:', url);
          this.showLoader();

          return originalFetch(...args)
            .then((response) => {
              const clonedResponse = response.clone();
              clonedResponse
                .json()
                .then((data) => {
                  this.queueUpdate('fetch-intercept', { cartData: data });
                })
                .catch(() => {
                  this.queueUpdate('fetch-intercept', {});
                });
              return response;
            })
            .catch((error) => {
              this.hideLoader();
              throw error;
            });
        }

        return originalFetch(...args);
      };
    }
  }

  // Legacy CartDrawerLoader removed - using unified CartUpdateManager instead

  // Global Loading State Manager
  // Initialize SimpleCartManager when DOM is ready
  if (document.readyState !== 'loading') {
    // Initialize SimpleCartManager immediately if DOM is ready
    setTimeout(() => {
      window.cartUpdateManager = new SimpleCartManager();
      console.log('SimpleCartManager initialized');
    }, 100);
  } else {
    // Wait for DOM to be ready
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        window.cartUpdateManager = new SimpleCartManager();
        console.log('SimpleCartManager initialized');
      }, 100);
    });
  }

  // Simplified event listeners - let individual operations handle their own loading
  document.addEventListener('cart:updating', (event) => {
    console.log('cart:updating event detected');
    // Individual cart operations will handle their own loading
  });

  document.addEventListener('cart:updated', (event) => {
    console.log('cart:updated event detected');
    // Individual cart operations will handle hiding their own loading
  });
